import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { RCUtils } from './../../../RCUtils';
import $ from 'jquery';
import { PopupWindow } from '../PopupWindow';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface DimiSettingGridState {
    SelectedReefers: any[],
    RowData: server.USP_UnitCurrentConditionUI_Model[],
    ForwardCommandParms: server.ForwardCommandParams;
    Filters: server.DimiSettingsParams
    VisibleDimiSetting: string;
    VisibleDimiValidity: string;
    VCCheckBoxInfo: VCCheckBoxData;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}
var self;

export class DimiSetting extends React.Component<any, DimiSettingGridState> {
    constructor(props: any) {
        super(props);
        self = this;
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        var forwardCommandParms: server.ForwardCommandParams = { SelectedReefers: [], CommandName: null, TempValue: null, PreTripCmdFilters: null, TraditionalDownload: null, lstAutoConfigParams: null, IsCmdSendViaVC: null, VesselInfo: null };
        this.state = { SelectedReefers: [], RowData: [], ForwardCommandParms: forwardCommandParms, Filters: filterSet, VisibleDimiSetting: 'row', VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [], VisibleDimiValidity:'row' };
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderDimiSettingsGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ SelectedReefers: reeferData, VisibleDimiSetting: 'row' });
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderDimiSettingsGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderDimiSettingsGrid(reeferData: any) {
        this.setState({ SelectedReefers: reeferData });
        this.SetDefaultDimiValidity(reeferData);
        var filterSet = this.setDefaultFilters();
        this.setState({ Filters: filterSet });
        this.state.ForwardCommandParms.CommandName = "DIMISettings";
        this.state.ForwardCommandParms.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData });
        var forwardCommandParams = JSON.stringify(this.state.ForwardCommandParms);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }
  /*  Updated method for RCNG - 5517OMP shall allow the user to disable DIMI Term*/
    DimiModeStatusChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        if (Value == 'On') {
            this.setState({ VisibleDimiSetting: 'row' });
            var filters = this.state.Filters;
            this.state.Filters.DimiMode = Value;
            this.setState({ Filters: filters });
        }
        else {

            if (this.state.SelectedReefers != null && this.state.SelectedReefers.length > 0) {
                var isDimiPriorFlag: boolean = false;
                if (this.state.SelectedReefers[0].UnitTypeCd.trim().toUpperCase() == 'DA' || this.state.SelectedReefers[0].UnitTypeCd.trim().toUpperCase() == 'DB') {
                    var softRevision = this.state.SelectedReefers[0].SoftwareRevision;
                    if (this.ValidateNumberValue(softRevision)) {

                        if (softRevision < '3106') {
                            isDimiPriorFlag = true;
                        }
                    }
                    else {
                        var strFirstTwo = softRevision.substring(0, 2);
                        var strSoftwarehex = softRevision.substring(2, 4);
                        var number = Number("0x" + strSoftwarehex)
                        if (parseInt(strFirstTwo) <= 30 && parseInt(number.toString()) < 77) {
                            isDimiPriorFlag = true;
                        }
                    }
                }

                if (isDimiPriorFlag) {
                    var filters = this.state.Filters;
                    var DimiModeValue = 'On';
                    this.state.Filters.DimiMode = DimiModeValue;
                    this.setState({ Filters: filters });

                    var warningMessage = 'DIMI Term can only be disabled for Va reefers running controller software version 304D or later and Vb reefers running controller software version 3106 or later.';
                    PopupWindow.showDIMIMessage('Alert', warningMessage);
                    event.currentTarget.value = 'On';
                    this.DimiModeStatusChange(event);
                }
                else {
                    var filters = this.state.Filters;
                    var DimiModeValue = 'Off';
                    this.state.Filters.DimiMode = DimiModeValue;
                    this.setState({ Filters: filters });
                    this.setState({ VisibleDimiSetting: 'disabled row' });
                }

            }
            else
                this.setState({ VisibleDimiSetting: 'disabled row' });
        }
   
    }
    DimiTypeStatusChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        var filters = this.state.Filters;
        this.state.Filters.DimiType = Value;
        this.setState({ Filters: filters });
    }
    DimiTermChange(event: React.FormEvent<HTMLInputElement>) {
        $('#cmbDimiModeStatus').focus();
        $('#txtDIMITerm').focus();
        var filters = this.state.Filters;
        var DimiTermValue = this.state.Filters.DimiTerm;
        var Value: string = event.currentTarget.value.trim();
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            DimiTermValue = Value;
        else
            return;

            this.state.Filters.DimiTerm = DimiTermValue;
            this.setState({ Filters: filters });
    }
    handleFocus() {
        $('#cmbDimiModeStatus').focus();
        $('#txtDIMITerm').focus();

    };
    DimidurationChange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value.trim();
        var filters = this.state.Filters;
        this.state.Filters.DimiDuration = Value;
        this.setState({ Filters: filters });
    }

    setDefaultFilters() {
        var filters: server.DimiSettingsParams = {
            DimiMode: 'On', DimiType: 'Short PTI', DimiTerm: '12', DimiDuration: 'Off'
        };
        return filters;
    }
    SetDefaultDimiValidity(reeferData: any) {
        var IsValidCount = 0;
        if (reeferData[0].UnitTypeCd != null && reeferData[0].UnitTypeCd.trim().toUpperCase() == 'DA') {
            var strFirstTwo = reeferData[0].SoftwareRevision.substring(0, 2);
            var strSoftwarehex = reeferData[0].SoftwareRevision.substring(2, 4);
            var number = Number("0x" + strSoftwarehex)
            if (parseInt(strFirstTwo) == 30 && 77 <= parseInt(number.toString()))
                IsValidCount++
        }
        else if (reeferData[0].UnitTypeCd != null && reeferData[0].UnitTypeCd.trim().toUpperCase() == 'DB') {
            var strFirstTwo = reeferData[0].SoftwareRevision.substring(0, 2);
            var strSoftwarehex = reeferData[0].SoftwareRevision.substring(2, 4);
            var number = Number("0x" + strSoftwarehex)
            if (parseInt(strFirstTwo) == 31 && 6 <= parseInt(number.toString()))
                IsValidCount++
        }
        //if (reeferData[0].UnitTypeCd != null && reeferData[0].UnitTypeCd.trim().toUpperCase() == 'DV') {
        //    IsValidCount++
        //}
        if (IsValidCount >= 1)
            this.setState({ VisibleDimiValidity: 'show' })
        else
            this.setState({ VisibleDimiValidity: 'hidden' })
    }
    ValidateNumberValue(param) {
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    submitDimiSettingCommand() {
        if (this.state.Filters.DimiMode == "On") {
            var AlertMessage = "";
            if (this.state.Filters.DimiTerm == undefined || this.state.Filters.DimiTerm == "")
                AlertMessage = "Please enter DIMI Term value.";
            else if (!this.ValidateNumberValue(this.state.Filters.DimiTerm) || !(parseInt(this.state.Filters.DimiTerm) >= 1 && parseInt(this.state.Filters.DimiTerm) <= 48))
                AlertMessage += "Please enter DIMI Term value between 1 and 48.";
            if (AlertMessage == '') {
                try {
                    var command = "DIMISettings";
                    var refreshGrid = this.props.refreshGrid;
                    var paramValue = this.state.Filters.DimiMode.toString() + ',' + this.state.Filters.DimiType.toString() + ',' + parseInt(this.state.Filters.DimiTerm).toString() + ',' + this.state.Filters.DimiDuration.toString();
                    this.submitTemperatureCommands(command, paramValue, refreshGrid);
                }
                catch (e) {
                    PopupWindow.showErrorMessage('Error', '');
                }
            }
            else {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }
        else {
            try {
                var command = "DIMISettings";
                var refreshGrid = this.props.refreshGrid;
                var paramValue = this.state.Filters.DimiMode.toString() + ',' + null + ',' + null + ',' + null;
                this.submitTemperatureCommands(command, paramValue, refreshGrid);
            }
            catch (e) {
                PopupWindow.showErrorMessage('Error', AlertMessage);
            }
        }

    }

    submitTemperatureCommands(commandName, paramValue, refreshGrid) {
        if (self.state.RowData.length > 0) {
            self.state.ForwardCommandParms.CommandName = commandName;
            self.state.ForwardCommandParms.SelectedReefers = self.state.RowData;
            self.state.ForwardCommandParms.TempValue = paramValue;
            var forwardCommandParams = JSON.stringify(self.state.ForwardCommandParms);
            ReeferCommandsGrid.submitTemperatureCommands(commandName, paramValue, refreshGrid);
            this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    public render() {
        return <div>
            <div className="well DimiSettings">
                <div className='row'>

                    <div className='col-md-6'>
                        <div className='row'>
                            <div className='col-md-6 pe-0 text-md-end'>
                                <label  className='col-form-label'>DIMI Mode :</label>
                            </div>
                            <div className='col-md-6'>
                                <select className='form-select' id='cmbDimiModeStatus' onChange={e => this.DimiModeStatusChange(e)} value={this.state.Filters.DimiMode}>
                                    <option key="ON">On</option>
                                    <option key="OFF">Off</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className={this.state.VisibleDimiSetting}>
                            <div className='col-md-6 pe-0 text-md-end'>
                                <label className='col-form-label'>DIMI Type :</label>
                            </div>
                            <div className='col-md-6'>
                                <select className='form-select' id='cmbDimiTypeStatus' onChange={e => this.DimiTypeStatusChange(e)} value={this.state.Filters.DimiType}>
                                    <option key="Short PTI">Short PTI</option>
                                    <option key="Full PTI">Full PTI</option>
                                </select>
                            </div>
                        </div>
                    </div>


                </div>
                <div className={this.state.VisibleDimiSetting + ' ' + 'mt-2'}>


                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-4 pe-0 text-md-end'>
                        <label className='col-form-label'>DIMI Term :</label>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-2'>

                        <input id="txtDIMITerm"
                            type="number"
                            min="1"
                            max="48"
                            step="1"
                            className="form-control"
                            placeholder="Enter range"
                            onChange={e => this.DimiTermChange(e)} value={this.state.Filters.DimiTerm} onClick={this.handleFocus}
                        />

                        {/*<div className="input-group input-group-info">*/}
                        {/*    <input type='text' className='form-control' placeholder='' required onChange={e => this.DimiTermChange(e)} value={this.state.Filters.DimiTerm} />*/}
                        {/*    <span className="input-group-text" title='Numeric value between 1 and 48 representing months'><span className="fas fa-info"></span></span>*/}
                        {/*</div>*/}

                    </div>

                   
                        <div className={this.state.VisibleDimiValidity + ' ' + 'col-lg-3 col-md-3 col-sm-3 col-xs-4 pe-0 text-md-end'}>
                        <label className='col-form-label'>DIMI Validity Duration :</label>
                    </div>
                        <div className={this.state.VisibleDimiValidity + ' ' + 'col-lg-3 col-md-3 col-sm-3 col-xs-2'}>
                        <select className='form-select' id='cmbDimiDurationStatus' onChange={e => this.DimidurationChange(e)} value={this.state.Filters.DimiDuration}>
                            <option key="OFF">Off</option>
                            <option key="10 days">10 days</option>
                            <option key="15 days">15 days</option>
                            <option key="30 days">30 days</option>
                            <option key="60 days">60 days</option>
                            <option key="90 days">90 days</option>
                            <option key="180 days">180 days</option>
                            <option key="360 days">360 days</option>
                        </select>
                    </div>



                </div>
            </div>
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"DIMISettings"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitDimiSettingCommand.bind(this)}>Save</button>

            </div>
        </div>
    }

}